class CartItemMessage extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      input: 'textarea'
    };
    this.init();
  }

  init() {
    this.input = this.querySelector(this.selectors.input);
    if (this.input) {
      this.input.addEventListener('input', this.debounce(this.handleInputChange.bind(this), 2000));
    }
  }

  handleInputChange() {
    const script = this.querySelector('script');
    const json = JSON.parse(script.textContent);
    json.properties = json.properties || {};

    // Fix: Properly set the dataset name property
    json.properties[this.input.dataset.name] = this.input.value;

    const data = {
      line: this.dataset.index,
      quantity: this.dataset.quantity,
      properties: json.properties // Fix: referencing `json.properties` correctly
    };

    const cartItem = this.closest('cart-items');
    if (cartItem) {
      cartItem.dispatchEvent(new CustomEvent('updateCart', {
        detail: { input: this.input, data: data, variantId: this.dataset.id },
        bubbles: true,
        composed: true
      }));
    }
  }


  debounce(func, wait) { 
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('cart-item-message', CartItemMessage);